import $ from 'jquery'

// Adding CSRF token for all AJAX calls
$.ajaxPrefilter(function(opts, origOpts, jqXHR) {
	let csrf = $('body').data('csrf')
	jqXHR.setRequestHeader('X-CSRF-Token', csrf);
});


document.getElementsByTagName('body')[0].setAttribute('donate-loaded', true);
